export const formTypes = {
  REGISTER: "register",
  UPDATE: "update",
};
